import PropTypes from "prop-types";
import React, { useEffect, useState, useRef } from "react";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Spinners from "../../components/Common/Spinner";
import { useNavigate } from 'react-router-dom'
import { useSelector, useDispatch } from "react-redux";
import './test.css'
//Import Flatepicker
import "flatpickr/dist/themes/material_blue.css";
import { Button, Col, Row, Modal, ModalHeader, ModalBody, Card, CardBody, Badge } from "reactstrap";
import axios from "axios";
import * as url from "../../helpers/url_helper";
//i18n

const MCQ = () => {

  const [isLoading, setLoading] = useState(true);
  const [activeQuestion, setActiveQuestion] = useState(0)
  const [showResult, setShowResult] = useState(false)
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [answeredCount, setAnsweredCount] = useState(0)
  const [markedCount, setMarkedCount] = useState(0)
  const [notAnsweredCount, setNotAnsweredCount] = useState(0)
  const [notAttendedCount, setNotAttendedCount] = useState(0)
  const [totalQuestion, setTotalQuestion] = useState("0")
  const [questions, setQuestions] = useState([])
  const [showNotes, setShowNotes] = useState(false);

  const [result, setResult] = useState({
    score: 0,
    correctAnswers: 0,
    wrongAnswers: 0,
  })

  useEffect(() => {
    const disableBackButton = (e) => {
      e.preventDefault(); // Prevent default behavior of back button
      window.history.forward(); // Move forward in history
    };
    // Push a new state to prevent going back
    window.history.pushState(null, "", window.location.href);

    window.onpopstate = function () {
      window.history.pushState(null, "", window.location.href)
    }
  
  }, []);

  useEffect(() => {
    bindMCQQuestions()
  }, [])
  const onClickviewAnswer = () => {
    setShowNotes(!showNotes);
    if (showNotes) {
      setShowNotes(false)
    } else {
      setShowNotes(true)
    }
  }
  async function bindMCQQuestions() {
    setLoading(true)
    try {
      const response = await axios.post(url.BASE_URL + 'site/getMCQ');
      if (response && response?.data?.body?.statusFlag === 3) {
        toast.error(response.data.body.message, { autoClose: 2000 });
        localStorage.removeItem("authUser");
        window.location.reload();
        return;
      }
      if (response?.data?.body?.statusFlag === 1) {
        var qaList = response?.data?.body?.questionList;
        setQuestions(qaList)
        qaList[activeQuestion]['attended'] = 1;
        setNotAttendedCount(qaList.filter(e => e?.attended != 1)?.length);
        setTotalQuestion(response?.data?.body?.questionList.length)
      } else {
        toast.error(response.data.body.message, { position: toast.POSITION.TOP_RIGHT });
      }
      setLoading(false)
    } catch (error) {
      // Handle error
      console.error("Get questions:", error);
      // navigate('/dashboard')
    } finally {

    }
  }

  useEffect(() => {
    document.addEventListener("contextmenu", handlecontextmenu)

    const handleKeyDown = (event) => {

      if (event.code === "MetaLeft" && event.keyCode === 91 && event.metaKey === true) {
        event.preventDefault()
      }


      // Ctrl + A 
      if (event.ctrlKey && (event.key === 'a' || event.key === 'A')) {
        // Prevent default behavior for Ctrl+A (select all)
        event.preventDefault();
      }
      // Ctrl + c
      if (event.ctrlKey && (event.key === 'c' || event.key === 'C')) {
        // Prevent default behavior for Ctrl+C (copy)
        event.preventDefault();
      }
      // // Inspect disabled
      if (event.ctrlKey && event.shiftKey && (event.key == 'i' || event.key === 'I')) {
        event.preventDefault();
      }
      if ((event.ctrlKey || event.metaKey) && (event.keyCode === 91)) { // Ctrl + S or Command + S
        event.preventDefault();
        // alert('Screenshots are disabled.');
      }
      if (event.key === "Meta") {
        event.preventDefault();
        // alert('=-=-=')
      }
      if ((event.key === "PrintScreen" || event.key === 'Meta') && (event.keyCode === 44 || event.keyCode === 91)
        && event.metaKey === 'true') {
        event.preventDefault();
        // alert('=-=-=')
      }

    }
    window.addEventListener('keydown', handleKeyDown);
    // Add event listener to capture Ctrl+A and Ctrl+C keydown events
    document.addEventListener('keydown', handleKeyDown);

    // document.addEventListener('keyup', (e) => {
    // console.log('e=====>', e)
    //     if (e.key == 'PrintScreen') {
    //         navigator.clipboard.writeText('');
    //         alert('Screenshots disabled!');
    //     }
    //     if((e.metaKey) && (e.keyCode == 91)){
    //         navigator.clipboard.writeText('');

    //         alert('dis')
    //     }
    //     if (event.key === 's' && event.metaKey && event.shiftKey) {
    //         event.preventDefault(); // Prevent the default behavior
    //         console.log('Windows + Shift + S is restricted');
    //     }
    // });
    document.addEventListener('keydown', function (event) {
      // Check if the key combination is Windows + PrintScreen
      if (event.key === 'PrintScreen' && (event.metaKey || event.ctrlKey)) {
        event.preventDefault(); // Prevent the default behavior
        console.log('Windows + PrintScreen is restricted');
      }

      // Check if the key combination is Windows + Shift + S
      if (event.key === 's' && event.metaKey && event.shiftKey) {
        event.preventDefault(); // Prevent the default behavior
        console.log('Windows + Shift + S is restricted');
      }
    });

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
      // document.removeEventListener("contextmenu",handlecontextmenu)
      document.removeEventListener('keydown', handleKeyDown);
    }


  }, [])

  const handlecontextmenu = (e) => {
    e.preventDefault()
  }

  const handleDragStart = (e) => {
    e.preventDefault(); // Prevent default drag behavior
  };


  useEffect(() => {
    setMarkedCount(questions.filter(e => e?.marked == 1)?.length);
    setAnsweredCount(questions.filter(e => e?.answered == 1)?.length);
    setNotAttendedCount(questions.filter(e => e?.attended != 1)?.length);
    setNotAnsweredCount(questions.filter(e => e?.attended == 1 && (e?.answered != 1 && e?.marked != 1))?.length);
  }, [questions])


  
  const onAnswerSelected = (answer, index) => {
   
    setQuestions(prevArray => {
      const newArray = [...prevArray]; // Create a copy of the original array

      for (var i = 0; i < newArray[activeQuestion]['optionList'].length; i++) {
        newArray[activeQuestion]['optionList'][i]['selectedanswer'] = 0;
        newArray[activeQuestion]['optionList'][i]['correctanswered'] = 0;
        if(newArray[activeQuestion]['actualansid'] == answer.qaid){
          newArray[activeQuestion]['optionList'][i]['correctanswered'] = 1
        }
        else{
            newArray[activeQuestion]['optionList'][i]['correctanswered'] = 0
        }
      }
      newArray[activeQuestion]['optionList'][index]['selectedanswer'] = 1

      newArray[activeQuestion]['answered'] = 1
      return newArray; // Return the new array
    });
   
  }

  const addLeadingZero = (number) => (number > 9 ? number : `0${number}`)

  //meta title
  // document.title = "Masters | Online Test";


  return (
    <React.Fragment>

      <div className="page-content pt-1"
      // onCopy={(event) => event.preventDefault()} onDragStart={handleDragStart} onKeyDown={(event) => {
      //   event.preventDefault();
      // }}
      >
        <Row>
          {isLoading ? (
            <Spinners setLoading={setLoading} />
          ) : (
            <Card>
              <CardBody>
                <Row>
                  <Col lg="12">
                    <div className="flex-grow-1 align-self-center">
                      <div className="text-muted">
                        <h2 className="text-center">
                         MCQ of the Day
                        </h2>
                      </div>
                    </div>
                  </Col>
                 
                </Row>
                <div style={{ borderTop: '1px solid grey', margin: '8px' }}></div>
                <Row>
                  <Col xs="12" lg="8">
                    <div className="quiz-container" >
                      {!showResult ? (
                        <div className="m-4">
                          <div>
                            {questions[activeQuestion]?.qt_contentflag == 1 ? (
                              <div className='ck-content' dangerouslySetInnerHTML={{ __html: questions[activeQuestion]?.qt_text }} />
                            ) : (
                              <h2>{questions[activeQuestion]?.qt_text}</h2>
                            )}
                            <ul>
                              {questions[activeQuestion]?.optionList?.map((answer, index) => (

                                <div className="row" key={answer} >
                                  <li
                                        className={answer?.selectedanswer === 1 && answer?.qa_answerflag === 1 ? 'selected-review-answer col-11' : answer?.selectedanswer === 0 && answer?.correctanswered === 0 && answer?.qa_answerflag === 1 ? 'selected-review-answer col-11' : answer?.selectedanswer === 1 && answer?.correctanswered === 0 ? 'wrong-answer col-11' : 'col-11'}
                                    style={{ cursor: 'pointer' }}
                                    // onMouseEnter={(e) => e.target.style.backgroundColor = 'lightgreen'}
                                    // onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                                    onClick={() => onAnswerSelected(answer, index)}
                                  >
                                    <input
                                      type="radio"
                                      name="answer"
                                      style={{ verticalAlign: 'middle' }}
                                      value={answer?.qaid}
                                      onChange={() => onAnswerSelected(answer, index)}
                                      checked={answer?.selectedanswer === 1}
                                    />
                                    {answer.qa_contentflag == 1 ? (
                                      <div className='ck-content' dangerouslySetInnerHTML={{ __html: answer.qa_name }} />
                                    ) : (
                                      <span> {answer.qa_name}</span>
                                    )}
                                  </li>
                                </div>
                              ))}
                            </ul>
                             <div style={{ justifyContent: 'left' }}>
                              {/* <div onClick={() => onClickviewAnswer()} className="btn btn-soft-success clrresponse">View Answer</div> */}

                              </div>
                              
                             {questions[activeQuestion]?.qt_notes != "" ?
                                <div  className="mt-3">

                                    <h2>Notes</h2>
                                    <div style={{backgroundColor:"#EEE", padding:8,marginRight:8}}>
                                  
                                  {questions[activeQuestion]?.qt_notes_contentflag == 1 ? <div className='ck-content' dangerouslySetInnerHTML={{
                                      __html: questions[activeQuestion]?.qt_notes
                                    }} />
                                      : <span>{questions[activeQuestion]?.qt_notes}</span>}
                                  </div>

                                </div>:''}

                          </div>
                         
                        </div>
                      ) : ''}
                    </div>

                  </Col>
                </Row>

              </CardBody>
            </Card>
          )}
        </Row>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
}
MCQ.propTypes = {
  preGlobalFilteredRows: PropTypes.any,

};


export default MCQ;
